import React, { useState, useEffect } from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import CarFilter from '../components/cars/CarFilter';
import CarList from '../components/cars/CarList';
import banner from '../assets/banner1.png';
import './Home.css';

const StockPage = () => {
  const [filters, setFilters] = useState({});

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    console.log('Filtre actualizate:', newFilters);
  };

  const handleSearch = (searchFilters) => {
    console.log('Caută cu filtrele:', searchFilters);
    // Curăță filtrele goale
    const cleanFilters = Object.entries(searchFilters).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});
    
    setFilters(cleanFilters);
  };
  return (
    <div>
      
      <main className="stockpage">
         {/* Secțiunea de filtrare */}
        <div style={{marginTop:'10px'}} className="filter-section">
          <CarFilter
            onFilterChange={handleFilterChange}
            onSearch={handleSearch}
          />
        </div>
        {/* Secțiunea cu mașinile */}
        <div className="cars-section">
          <div style={{marginBottom:'20px'}} className="section-header">
            <h2>Parcul nostru auto</h2>
            <p>Descoperă cele mai bune oferte</p>
          </div>
          <CarList filters={filters} />
        </div>
      </main>
      
    </div>
  );
};

export default StockPage;
